<script>
    export default {
        props: {
            label: String,
            value: String,
            disabled: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                val: 0,
            }
        },
        methods: {
            change(v){
                this.$emit('change', v);
            }
        },
        computed: {
            pickerOptions(){
                return{
                    firstDayOfWeek: 1,
                }
            }
        },
        watch: {
            value(v){
                this.val= v;
            },
            val(v){
                this.$emit('input', v);
            },
        },
        components: {},
        mounted() {
            this.val = this.value;

        },
        destroyed() {
        },
    }
</script>
<template>
    <div class="input-textarea">
        <div class="el-input-group el-input--mini" :class="{'el-input-group--prepend': label}">
            <div class="el-input-group__prepend" v-if="label">
                {{label}}
            </div>
            <el-input
                    type="textarea"
                    @change="change"
                    :rows="2"
                    :autosize="{ minRows: 2, maxRows: 5}"
                    v-model="val">
            </el-input>
        </div>
    </div>
</template>
<style lang="scss">
    .input-textarea {
        position: relative;
        .el-textarea__inner{
            border-radius: 0 4px 4px 0;
        }
    }
</style>
